"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const IMAGE_BASE = "/image/new-version/fabrication/metal-welding/Quality";

const QC_IMAGES = [
	`${IMAGE_BASE}/trusted-sheet-metal-parts-made-right-1.webp`,
	`${IMAGE_BASE}/trusted-sheet-metal-parts-made-right-2.webp`,
	`${IMAGE_BASE}/trusted-sheet-metal-parts-made-right-3.jpg`,
	`${IMAGE_BASE}/trusted-sheet-metal-parts-made-right-4.webp`,
] as const;

const CONTENT_BLOCKS = [
	{
		titleKey: "weldingPrecisionQualityBlock1Title" as const,
		descKey: "weldingPrecisionQualityBlock1Desc" as const,
	},
	{
		titleKey: "weldingPrecisionQualityBlock2Title" as const,
		descKey: "weldingPrecisionQualityBlock2Desc" as const,
	},
	{
		titleKey: "weldingPrecisionQualityBlock3Title" as const,
		descKey: "weldingPrecisionQualityBlock3Desc" as const,
	},
] as const;

const LEARN_MORE_HREF = "/quality-assurance";

export default function MetalWeldingPrecisionQuality() {
	const t = useTranslations("new-welding");

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("weldingPrecisionQualityTitle")}
					</h2>
					<p className="mt-3 text-sm leading-relaxed text-gray-600 sm:mt-4 md:text-base">
						{t("weldingPrecisionQualityDesc")}
					</p>
				</header>

				<div className="grid grid-cols-1 items-start gap-8 lg:grid-cols-2">
					<div className="grid grid-cols-2 gap-3 sm:gap-4">
						{QC_IMAGES.map((src, index) => (
							<div key={src} className="relative aspect-[3/2.4] bg-white">
								<Image
									src={src}
									alt={t(`weldingPrecisionQualityImageAlt${index + 1}`)}
									fill
									className="object-cover"
									sizes="(max-width: 1024px) 50vw, 25vw"
								/>
							</div>
						))}
					</div>

					<div className="flex flex-col gap-6 sm:gap-8 md:gap-10">
						{CONTENT_BLOCKS.map((block) => (
							<div key={block.titleKey}>
								<h3 className="mb-2 text-base font-bold text-themePrimary400 sm:mb-3 sm:text-lg md:text-xl">
									{t(block.titleKey)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t(block.descKey)}</p>
							</div>
						))}

						<div>
							<Link
								href={LEARN_MORE_HREF}
								className="inline-flex items-center text-sm font-semibold text-themePrimary400 transition hover:text-[#83b751] md:text-base"
							>
								{t("weldingPrecisionQualityLearnMore")}
							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
